import React, { Fragment, useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CustomButton from "../Buttons/Button";
import { Autocomplete, IconButton, Stack, TextField } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import { updateTimeline } from "../../store/actions/investment/updateTimeline";
import { useFormik } from "formik";
import { updateTimelineSchema } from "../../Helper/validationSchemas";
import SelectField from "../inputs/SelectField";
import { MdOutlineEdit } from "react-icons/md";
import HalDatePicker from "../inputs/HalDatePicker";
import dayjs from "dayjs";
import { getServerDate, timeformatter } from "../../config/dateformatter";

import { getInvestmentTimeline } from "../../store/actions/investment/getInvestmentTimeline";
import Loader from "../SharedLayouts/Loader";
import { editInvestmentTimeline } from "../../store/actions/investment/editInvestmentTimeline";
import CustomInput from "../inputs/CustomInput";
import ConfirmModal from "./ConfirmDeleteModal";
import { deleteInvestmentTimeline } from "../../store/actions/investment/deleteInvestmentTimeline";

const UpdatTimelineModal = ({ open, onClose, investment_id }) => {
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const _investment_type =
    open?.investment?.investment_category?.name?.toLowerCase() ===
      "sme financing" ||
    open?.investmentCategory?.name?.toLowerCase() === "sme financing"
      ? "business"
      : open?.investment?.investment_category?.slug;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [action, setAction] = useState({ type: "VIEW" });
  const dispatch = useDispatch();
  const { timelines } = useSelector((state) => state?.investment);

  const handleSubmit = (values, { setSubmitting }) => {
    if (action?.type === "ADD") {
      dispatch(
        updateTimeline({
          data: {
            title: values?.stageValue,
            send_email: values?.send_email,
            description: values?.description,
            status: values?.status?.value,
            investment_type: _investment_type,
            cycle_id: open?.id,
            investment_id: investment_id,
            date: form.values?.date ? getServerDate(form.values?.date) : null,
          },
          onClose,
          setSubmitting,
        })
      );
    } else {
      dispatch(
        editInvestmentTimeline({
          payload: {
            title: values?.stageValue,
            description: values?.description,
            send_email: values?.send_email,
            status: values?.status?.value,
            investment_type: _investment_type,
            cycle_id: open?.id,

            date: form.values?.date ? getServerDate(form.values?.date) : null,
          },
          investment_id: investment_id,
          timeline_id: action?.details?.id,
          cb: (data) => {
            onClose();
            setSubmitting(false);
          },
          failed: () => {
            setSubmitting(false);
          },
        })
      );
    }
  };
  const form = useFormik({
    initialValues: {
      send_email: false,
      stageValue: timelines ? timelines[0]?.title : "",
      status: {
        label: "Pending",
        value: "Pending",
      },
      description: "",
      stage: timelines
        ? {
            label: timelines[0]?.title,
            value: timelines[0]?.title,
            id: timelines[0]?.id,
          }
        : null,

      // date: dayjs(new Date()),
    },
    validationSchema: updateTimelineSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    dispatch(
      getInvestmentTimeline({
        payload: {
          cycle_id: open?.id,
          investment_type: _investment_type,
        },
        investmentId: investment_id,
        cb: (data) => {
          setData(data);
          setLoading(false);
        },
        failed: () => {
          setLoading(false);
        },
      })
    );
  }, []);

  const handleDelete = () => {
    setLoadingDelete(true);
    dispatch(
      deleteInvestmentTimeline({
        investment_id: investment_id,
        timeline_id: action?.details?.id,
        cycle_id: open?.id,
        investment_type: _investment_type,
        cb: () => {
          setLoadingDelete(false);
          onClose();
        },
        failed: () => {
          setLoadingDelete(false);
        },
      })
    );
  };

  return openConfirmModal ? (
    <ConfirmModal
      handleDelete={handleDelete}
      onClose={onClose}
      loading={loadingDelete}
      open={openConfirmModal}
    />
  ) : (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          maxHeight: "80%",
          overflowY: "scroll",
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 3,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            top: 19,
            right: 10,
          }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>
        {loading ? (
          <Loader />
        ) : action?.type === "VIEW" ? (
          data?.length > 0 ? (
            <>
              <h2 className="font-[500] text-[24px] mt-2 mb-2">
                {open?.investment?.name} Timeline
              </h2>

              <div className="flex  items-start gap-[12px] ">
                <div className="flex flex-col gap-[8px] items-center mt-[10px]">
                  {data?.map((timeline, index) => {
                    return (
                      <Fragment key={index}>
                        <div className="flex flex-col items-center">
                          {timeline?.status?.toLowerCase() !== "pending" ? (
                            <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#16a267] flex justify-center items-center">
                              <div className="w-[7px] h-[7px] bg-[#16a267] rounded-full"></div>
                            </div>
                          ) : (
                            <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#9c9c9e] flex justify-center items-center">
                              <div className="w-[7px] h-[7px] bg-transparent rounded-full"></div>
                            </div>
                          )}
                        </div>
                        {data?.length === index + 1 ? (
                          <></>
                        ) : (
                          <div className="w-[1px] border-l-[1px] border-dashed border-[#131e3d] h-[50px]"></div>
                        )}
                      </Fragment>
                    );
                  })}
                </div>
                <div className="flex flex-col mt-[4px] ">
                  {data?.map((timeline, index) => {
                    return (
                      <div className="flex gap-4  ">
                        <div
                          key={index}
                          className={`text-[16px] h-[80px] ${
                            timeline?.date ? "text-[#131e3d]" : "text-[#9C9C9E]"
                          } ] font-[500]`}
                        >
                          {timeline?.title}
                          <div className="text-[14px] font-[400] text-[#9C9C9E]">
                            {timeline?.date
                              ? timeformatter(timeline?.date, "formal")
                              : "___"}
                          </div>
                        </div>
                        <MdOutlineEdit
                          onClick={() => {
                            setAction({ type: "EDIT", details: timeline });
                            form.setValues({
                              send_email: false,
                              description: timeline?.description || "",
                              stageValue: timeline?.title,
                              status: timelines
                                ? {
                                    label: timeline?.status,
                                    value: timeline?.status,
                                    id: timeline?.id,
                                  }
                                : {
                                    label: "Pending",
                                    value: "Pending",
                                  },
                              stage: timelines
                                ? {
                                    label: timeline?.status,
                                    value: timeline?.status,
                                    id: timeline?.id,
                                  }
                                : null,

                              date: dayjs(new Date(timeline?.date)),
                            });
                          }}
                          className="cursor-pointer text-[#159AA8] text-[20px] my-2"
                        />
                      </div>
                    );
                  })}
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", mt: 2 }}>
                <CustomButton
                  variant="contained"
                  customColor="#159AA8"
                  children="Add New"
                  width="100%"
                  height="46px"
                  padding="10px"
                  margin="15px 0"
                  color="#fff"
                  onClick={() => {
                    setAction({ type: "ADD" });
                  }}
                />
              </div>
            </>
          ) : (
            <div className="w-full flex-col h-[400px] flex justify-center items-center">
              <img
                src={"/Assets/recent.png"}
                alt=""
                className=" mb-[5px] w-[76px] h-[76px] "
              />
              <h4
                onClick={() => {
                  setAction({ type: "ADD" });
                }}
                className=" mb-[5px] p-2 text-[16px] font-[400] cursor-pointer text-[#159AA8] "
              >
                Upload Timeline
              </h4>
            </div>
          )
        ) : (
          <>
            <h2 className="font-[500] text-[24px] mt-2 mb-2">
              {action?.type === "ADD" ? "Add New" : "Update"} Timeline
            </h2>

            {action?.type === "ADD" ? (
              <Stack spacing={2} sx={{ width: "100%", marginBottom: "16px" }}>
                <Autocomplete
                  id="free-solo-demo"
                  freeSolo
                  options={timelines?.map((timeline) => ({
                    ...timeline,
                    label: timeline?.title,
                  }))}
                  value={form?.values?.stage}
                  onChange={(_, newValue) => {
                    form?.setFieldValue("stage", newValue);
                    form.setFieldValue("stageValue", newValue?.label);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label=""
                      onChange={(e) => {
                        form.setFieldValue("stageValue", e.target.value);
                      }}
                      id="stage"
                      sx={{
                        // height: "52px",
                        // Root class for the input field
                        "& .MuiOutlinedInput-root": {
                          color: "#131E3D",

                          fontWeight: "400",
                          height: "52px",
                          // Class for the border around the input field
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#F2F2F7",
                            borderRadius: "8px",
                            borderWidth: "1.3px",
                          },
                        },
                        "&.Mui-focused": {
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#F2F2F7",
                            borderRadius: "8px",
                            borderWidth: "1.3px",
                          },
                        },
                        // Class for the label of the input field
                        "& .MuiInputLabel-outlined": {
                          color: "#131E3D",

                          fontWeight: "400",
                        },
                      }}
                    />
                  )}
                />
              </Stack>
            ) : (
              <CustomInput
                id="stageValue"
                width="100%"
                form={form}
                placeholder={"Enter Name"}
                height="16px"
                mt="10"
                mr="10px"
                mb="10px"
                borderRadius={"10px"}
                className="mobile-input-width"
              />
            )}
            <div>
              <CustomInput
                id="description"
                type={"textarea"}
                width="100%"
                form={form}
                placeholder={"Enter Description"}
                height="100px"
                multiline={true}
                minRows={2}
                maxRows={2}
                mt="10"
                mr="10px"
                mb="50px"
                borderRadius={"10px"}
                className="mobile-input-width"
              />
            </div>

            <div className=" mb-4 lg:mb:0  w-full">
              <SelectField
                placeholder="Select Status"
                id="status"
                form={form}
                options={[
                  {
                    label: "Pending",
                    value: "Pending",
                  },
                  {
                    label: "Completed",
                    value: "Completed",
                  },
                ]}
                sx={{
                  width: "100%",
                  padding: "1px",
                  height: "52px",
                  borderRadius: "10px",
                  marginTop: "1px",
                }}
                className="mobile-select"
              />
            </div>

            <HalDatePicker
              type={2}
              label="Date"
              id={"date"}
              form={form}
              small
              rightImage
              className="-mr-5"
            />
            <div className="mt-5 p-2" id="terms">
              <label style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  id="send_email"
                  checked={form?.values?.send_email}
                  onChange={() => {
                    form.setFieldValue(
                      "send_email",
                      form?.values?.send_email ? false : true
                    );
                  }}
                  style={{ width: "24px", height: "24px", marginRight: "10px" }}
                />
                <span>Send notification</span>
              </label>
            </div>
            <div
              style={{ display: "flex", gap: 12, alignItems: "center", mt: 2 }}
            >
              {action?.type === "ADD" ? (
                <></>
              ) : (
                <CustomButton
                  variant="contained"
                  customColor="#B42318"
                  children={"Delete"}
                  width="100%"
                  height="45px"
                  padding="10px"
                  margin="15px 0"
                  loading={loadingDelete}
                  color="#fff"
                  onClick={() => {
                    setOpenConfirmModal(true);
                  }}
                />
              )}

              <CustomButton
                variant="contained"
                customColor="#159AA8"
                children={action?.type === "ADD" ? "Submit" : "Update"}
                width="100%"
                height="46px"
                padding="10px"
                margin="15px 0"
                color="#fff"
                disabled={form?.isSubmitting || !form?.isValid}
                loading={form?.isSubmitting}
                onClick={form.handleSubmit}
              />
            </div>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default UpdatTimelineModal;
